import { ReactElement } from "react";
import { useDependency } from "../../contexts/DependencyContext";
import useGlobalPanels from "../../hooks/UseGlobalPanels";
import { LoginService } from "../../services/LoginService";
import { header } from "../../shared/logos";
import styles from "./NotFoundPage.module.scss";

export default function NotFoundPage(): ReactElement
{
    const loginService = useDependency(LoginService);
    const isAuthenticated = loginService.isAuthenticated();

    useGlobalPanels(isAuthenticated);

    return (

        <main className={styles.loginOverlay}>
            <div className={styles.login}>
                <div className={styles.headerWrapper}>
                    {header}
                </div>

                <div className={styles.contentWrapper}>
                    <h1>Page Not Found</h1>
                    <p>The page you are trying to access does not exist.</p>
                    <p>Go back to the {isAuthenticated ? <a href="/dashboard">Dashboard</a> : <a href="/login">Login Page</a>}
                    </p>
                </div>
            </div>
        </main>
    );
}